var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1903_95002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3667 42.5333C35.1892 42.5333 36.6667 41.0559 36.6667 39.2333C36.6667 37.4108 35.1892 35.9333 33.3667 35.9333C31.5441 35.9333 30.0667 37.4108 30.0667 39.2333C30.0667 41.0559 31.5441 42.5333 33.3667 42.5333Z",
    fill: "#2C3B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6333 42.5333C56.4559 42.5333 57.9333 41.0559 57.9333 39.2333C57.9333 37.4108 56.4559 35.9333 54.6333 35.9333C52.8108 35.9333 51.3333 37.4108 51.3333 39.2333C51.3333 41.0559 52.8108 42.5333 54.6333 42.5333Z",
    fill: "#2C3B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.25 74.25L64.1781 66L54.0719 74.25L44 66L33.9281 74.25L23.8219 66L13.75 74.25V41.25C13.75 33.2272 16.937 25.533 22.61 19.86C28.283 14.187 35.9772 11 44 11C52.0228 11 59.717 14.187 65.39 19.86C71.063 25.533 74.25 33.2272 74.25 41.25V74.25Z",
    stroke: "#2C3B60",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1903_95002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/Ghost.e6fd1ba0923d26ae058b3126cdc05bcc.svg";
export { ForwardRef as ReactComponent };